'use strict';

(function (global) {

  // Масштаб по умолчанию в процентах
  const DEFAULT_SCALE = '100';

  // Идентификатор для хранения приватного свойства с масштабом, устанавливаемым кнопкой тулбара
  const toolbarButtonScalePrivatePropertyKey = Symbol('scale');

  /**
   * Кнопка тулбара предпросмотра.
   *
   * @namespace window.Core.preview.toolbar
   * @since 5.7.0
   */
  class FitToToolbarButton extends global.SelectableToolbarButton {

    constructor(buttonSelector, buttonScale) {
      super(buttonSelector, (scale) => window.Core.preview.actions.setScale(scale));
      this[toolbarButtonScalePrivatePropertyKey] = buttonScale;
    }

    /**
     * Способ масштабирования документа (например, по ширине)
     *
     * @private
     * @property _scale
     * @return {string}
     */
    get _scale() {
      return this[toolbarButtonScalePrivatePropertyKey];
    }

    /**
     * @see BaseToolbarButton._performAction
     */
    _performAction() {
      const shouldFitToScale = !this.isTurnedOn;
      // Сбрасываем "нажатость" у всех кнопок "масштабировать по" перед выполнением действия
      $('#preview-panel .fit-to').removeClass('selected');
      if (shouldFitToScale) {
        this.turnOn();
      }
      this._toggleAction(shouldFitToScale);
    }

    /**
     * @see BaseToolbarButton._toggleAction
     */
    _toggleAction(shouldFitToScale) {
      let scale = shouldFitToScale ? this._scale : DEFAULT_SCALE;
      this._action(scale);
    }
  }

  global.FitToToolbarButton = FitToToolbarButton;

})(window.Core.preview.toolbar);